import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Clipboard } from '@capacitor/clipboard';
import { ENVIRONMENT } from '@core/core.constants';
import { MastersService } from '@core/services/masters.service';
import { UiService } from '@core/services/ui.service';
import { InscriptionService } from '@core/use-case-services/inscription.service';

@Component({
  selector: 'gt-payment-transfer',
  templateUrl: './payment-transfer.page.html',
  styles: [
    `
      .text-destacadoM {
        font-family: 'Bree';
      }
    `,
  ],
})
export class PaymentTransferPage implements OnInit {
  inscriptionId = this.route.snapshot.params['inscriptionId'];
  environment = inject(ENVIRONMENT);
  bankAccount$ =
    this.environment.appType === 'maroc'
      ? this.masterService.settings.getSetting('bankAccountMaroc')
      : this.masterService.settings.getSetting('bankAccountTunisie');

  amountToPay = 0;
  loading = true;
  showAcceptButton = false;
  constructor(
    private ui: UiService,
    private masterService: MastersService,
    private route: ActivatedRoute,
    private inscriptionService: InscriptionService,
  ) {}

  async ngOnInit() {
    this.showAcceptButton = this.environment.platform === 'app';
    const inscriptionData = await this.inscriptionService.getInscriptionTotal(this.inscriptionId);

    // If it's the first payment (paidAmount === 0) and paymentOption is 'registration'
    // show only the rate amount. Otherwise show the full pending amount.
    if (inscriptionData.paidAmount === 0 && inscriptionData.paymentOption === 'registration') {
      this.amountToPay = inscriptionData.breakdown.ratePrice;
    } else {
      this.amountToPay = inscriptionData.pendingAmount;
    }

    this.loading = false;
  }

  async copy(text: string) {
    await Clipboard.write({ string: text });
    this.ui.showToast('CHECKOUT.PAYMENT_TRANSFER.COPIED_OK', 'secondary');
  }
}
